var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimeNotImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "#F03B2A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3327 14.6666H19.9993C15.9993 14.6666 14.666 17.0533 14.666 20V21.3333V40C14.666 41.1066 15.9193 41.7333 16.7993 41.0666L19.0793 39.36C19.6127 38.96 20.3593 39.0133 20.8393 39.4933L23.0527 41.72C23.5727 42.24 24.426 42.24 24.946 41.72L27.186 39.48C27.6527 39.0133 28.3993 38.96 28.9193 39.36L31.1993 41.0666C32.0793 41.72 33.3327 41.0933 33.3327 40V17.3333C33.3327 15.8666 34.5327 14.6666 35.9993 14.6666H21.3327ZM27.666 26.3333H20.3327C19.786 26.3333 19.3327 25.88 19.3327 25.3333C19.3327 24.7866 19.786 24.3333 20.3327 24.3333H27.666C28.2127 24.3333 28.666 24.7866 28.666 25.3333C28.666 25.88 28.2127 26.3333 27.666 26.3333Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.014 14.6666V16.6666C36.894 16.6666 37.734 17.0266 38.3473 17.6266C38.9873 18.28 39.334 19.12 39.334 20V23.2266C39.334 24.2133 38.894 24.6666 37.894 24.6666H35.334V17.3466C35.334 16.9733 35.6407 16.6666 36.014 16.6666V14.6666ZM36.014 14.6666C34.534 14.6666 33.334 15.8666 33.334 17.3466V26.6666H37.894C40.0007 26.6666 41.334 25.3333 41.334 23.2266V20C41.334 18.5333 40.734 17.2 39.774 16.2266C38.8007 15.2666 37.4807 14.68 36.014 14.6666C36.0273 14.6666 36.014 14.6666 36.014 14.6666Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeNotImg);
export default __webpack_public_path__ + "static/media/timeNotImg.45e6c429e8880793936907fb3dcbb096.svg";
export { ForwardRef as ReactComponent };